export const EntityTypes = {
  dealers: 'dealers',
  groups: 'groups'
} as const;

export type EntityTypeEnum = typeof EntityTypes[keyof typeof EntityTypes];
